import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    PakmailShipmentEvent,
    CreatePakmailShipmentEventInput,
    UpdatePakmailShipmentEventInput,
    DeletePakmailShipmentEventInput,
    ModelPakmailShipmentEventFilterInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class PakmailShipmentEventService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPakmailShipmentEvents(
        filter: ModelPakmailShipmentEventFilterInput = null
    ): Promise<PakmailShipmentEvent[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPakmailShipmentEvents,
                    variables: {
                        filter
                    }
                })
            ).data.listPakmailShipmentEvents.items;
            if (data) return data as PakmailShipmentEvent[];
        } catch (error) {
            console.error('Error finding listPakmailShipmentEvents:', error);
            return null;
        }
    }

    async createPakmailShipmentEvent(
        input: CreatePakmailShipmentEventInput
    ): Promise<PakmailShipmentEvent> {
        try {
            const pakmailShipmentEvent = (
                await this.amplifyClient.graphql({
                    query: mutations.createPakmailShipmentEvent,
                    variables: {
                        input
                    }
                })
            ).data.createPakmailShipmentEvent;
            if (pakmailShipmentEvent)
                return pakmailShipmentEvent as PakmailShipmentEvent;
        } catch (error) {
            console.error('Error creating pakmailShipmentEvent:', error);
            return null;
        }
    }

    async updatePakmailShipmentEvent(
        input: UpdatePakmailShipmentEventInput
    ): Promise<PakmailShipmentEvent> {
        try {
            const pakmailShipmentEvent = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePakmailShipmentEvent,
                    variables: {
                        input
                    }
                })
            ).data.updatePakmailShipmentEvent;
            if (pakmailShipmentEvent)
                return pakmailShipmentEvent as PakmailShipmentEvent;
        } catch (error) {
            console.error('Error updating pakmailShipmentEvent:', error);
            return null;
        }
    }

    async deletePakmailShipmentEvent(
        input: DeletePakmailShipmentEventInput
    ): Promise<PakmailShipmentEvent> {
        try {
            const pakmailShipmentEvent = (
                await this.amplifyClient.graphql({
                    query: mutations.deletePakmailShipmentEvent,
                    variables: {
                        input
                    }
                })
            ).data.deletePakmailShipmentEvent;
            if (pakmailShipmentEvent)
                return pakmailShipmentEvent as PakmailShipmentEvent;
        } catch (error) {
            console.error('Error deleting pakmailShipmentEvent:', error);
            return null;
        }
    }
}
